module.exports = __webpack_public_path__ + "static/media/icon_inbox_ejerciciocaligrafico.43b426be.svg";